import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { UserData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Box, Grid, Paper } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        boxLine: {
            border: '1px solid #ebdcc6',
            borderRadius: '4px',
            boxShadow: 'none',
            padding: 10,
            backgroundColor: '#ffffff'
        },
        boxTitle: {
            paddingBottom: 10,
            paddingTop: 10,
            fontWeight: 'bold',
            fontSize: '18px'
        },
        largeTitle: {
            paddingBottom: 15,
            fontWeight: 'bold',
            fontSize: '20px'
        },
        text: {
            fontSize: '14px',
            lineHeight: '25px'
        },
        textLink: {
            color: 'inherit',
            textDecoration: 'none',
        }
    }),
);

interface PropsFromState {
    token: UserData["token"];
}

interface propsFromDispatch {
}

type AllProps = PropsFromState & propsFromDispatch;

const Contacts: React.FC<AllProps> = ({
    token
}) => {
    useEffect(() => { }, [token]);

    const classes = useStyles();

    return (
        <>
            <Box p={4} pr={3} pl={3}>
                <Box className={classes.largeTitle} textAlign="center">
                <FormattedMessage id="nav.contacts" />
                </Box>
                <Grid
                    container
                    spacing={4}
                    direction="row"
                    justify="center"
                >
                    <Grid item xs={12} sm={6}>
                        <Box className={classes.boxTitle}><FormattedMessage id="contacts.contactInfo" /></Box>
                        <Box className={classes.boxLine}>
                            <span className={classes.text}>
                                <FormattedMessage id="contacts.officeWarehouseAddress" />: <b>Jelgavas iela 28, Rīga, LV-1004</b><br />
                            <FormattedMessage id="register.phone" />: <b><a className={classes.textLink} href="tel:+37122116630">(+371) 22116630</a></b><br />
                            <FormattedMessage id="register.phone" />: <b><a className={classes.textLink} href="tel:+37129236283">(+371) 29236283</a></b><br />
                            <FormattedMessage id="register.email" />: <b><a className={classes.textLink} href="mailto:retro@bpgroup.lv">retro@bpgroup.lv</a></b>
                            </span>
                        </Box>
                        <Box className={classes.boxTitle}><FormattedMessage id="contacts.workingHours" /></Box>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            spacing={2}
                        >
                            <Grid item xs={6} sm={6}>
                        <Paper className={classes.boxLine}>
                                <span className={classes.text}>
                                    <b><FormattedMessage id="contacts.warehouseHours" /></b><br />
                                9:00-17:30<br />
                                <FormattedMessage id="contacts.holidays" />: <FormattedMessage id="contacts.closed" />
                            </span>
                            </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                        <Paper className={classes.boxLine}>
                                <span className={classes.text}>
                                    <b><FormattedMessage id="contacts.officeHours" /></b><br />
                                8:30-18:00<br />
                                <FormattedMessage id="contacts.holidays" />: <FormattedMessage id="contacts.closed" />
                            </span>
                            </Paper>
                            </Grid>
                        </Grid>

                        <Box className={classes.boxTitle}><FormattedMessage id="contacts.companyDetails" /></Box>
                        <Box className={classes.boxLine}>
                            <span className={classes.text}>
                                Baltic Project Group SIA<br />
                            <FormattedMessage id="contacts.registrationNumber" />: 40002078769<br />
                            <FormattedMessage id="contacts.vatNumber" />: LV40002078769<br />
                            <FormattedMessage id="contacts.legalAddress" />:<br />
                            Jelgavas iela 28, Rīga, LV-1004<br />
                            <FormattedMessage id="contacts.bank" />: SEB banka A/S<br />
                            <FormattedMessage id="contacts.swiftCode" />: UNLALV2X<br />
                            <FormattedMessage id="contacts.account" />: LV49UNLA0055001595158
                        </span>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img src="./images/Map.png" alt="" width="100%" />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

const mapStateToProps = ({ user }: ApplicationState) => ({
    token: user.user["token"]
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
